import Vue from 'vue'
import Vuex from 'vuex'
import Router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    email: undefined,
    role: undefined,
    weezy_id: undefined,
    fullname: undefined
  },
  mutations: {
    logout() {
      localStorage.removeItem('access_token'); // Remove access token
      Router.push({ name: "login" });
    },
    login(state, payload) {
      localStorage.setItem('access_token', payload.token);
      state.email = payload.email;
      state.role = payload.role;
      state.weezy_id = payload.weezy_id;
      state.fullname = payload.fullname;
      Router.push({ name: "dashboard" });
    }
  },
  actions: {


  }
})
